import React from "react";
import { Select, SelectProps } from "antd";
import CommonIcons from "../../../assets/icons";
import { useTranslation } from "react-i18next";

interface IProps extends SelectProps
{
  className?: string;
  label?: string;
  data?: any;
  disabled?: boolean;
  onSelect?: any;
  nameValue?: string;
  required?: boolean;
  nameLabel?: string;
  style?: any;
  optional?: boolean;
}

export default function SelectUI({
  className,
  label,
  data,
  disabled,
  onSelect,
  nameValue,
  required,
  nameLabel,
  style,
  optional,
  ...res
}: IProps)
{
  const { t } = useTranslation();

  return (
    <>
      {label && (
        <p className="mb-2 text-[var(--color-label-form)] text-sm">
          {label}
          {optional && (
            <span className="text-common-line">{` (${t("Optional")})`}</span>
          )}

          {required && <span className="text-common-red500">{` *`}</span>}
        </p>
      )}

      <Select
        className={` ${className ? ` ${className}` : ""}`}
        onSelect={onSelect}
        disabled={disabled}
        style={{ borderRadius: "4px", ...style }}
        suffixIcon={
          <div className="rotate-180">
            <CommonIcons.ChevronUpIcon />
          </div>
        }
        {...res}
      >
        {data?.length > 0
          ? data?.map((item: any) => (
            <Select.Option


              value={
                nameValue ? item?.[nameValue] : item?.value ?? item?.name
              }
            >
              {nameLabel ? item?.[nameLabel] : item?.label ?? item?.name}
            </Select.Option>
          ))
          : null}
      </Select>
    </>
  );
}
